require("./wdh-legacy/news-list-spot/js/base/component-news-list-spot.js");
(function ($) {
  window.DGS.NewsListSpotConfig.equalHeaderHeight = false;
  window.DGS.NewsListSpotConfig.equalLocationHeight = true;
  window.DGS.NewsListSpotConfig.equalDateHeight = true;
  window.DGS.NewsListSpotConfig.equalTextHeight = false;
})(jQuery);